<script setup lang="ts">
const { t } = useI18n()
const total = ref(0)
const isLoading = ref(false)

const images = import.meta.glob('~/assets/homepage/*', { eager: true, import: 'default' })

const title = computed(() => t('layouts.title', [t('pages.title.index')]))

useSeoMeta({
  title,
  ogTitle: title,
})
</script>

<template>
  <div>
    <CollectionsGrid />
    <div class="mx-auto mt-4 max-w-3xl px-4 lg:max-w-[88rem] md:max-w-4xl lg:px6 sm:px-6 sm:px4">
      <CollectionsProductGridCTA
        :search="{ collectionId: '4944', sort: { sales: 'DESC' as SortOrder.DESC }, take: 8 }"
        :banner-image="images['/assets/homepage/dress.png'] as string"
        bg-color="bg-orange-100"
      >
        <h2 class="text-center text-xl text-orange-800 fw500 md:text-2xl">
          {{ t('homepage.collection_cta.new_dress_collection') }}
        </h2>
        <h3 class="mt2 whitespace-nowrap text-center text-orange-800 fw500 uppercase">
          {{ t('homepage.collection_cta.sale') }}
          <span class="rd-md bg-orange-800 px1.5 py1 text-white">40%</span> !
        </h3>

        <NuxtLinkLocale
          to="/collections/4944"
          class="z-2 w-fit rd-md bg-orange-800 px4 py1 text-center text-sm text-white shadow-md lg:absolute lg:bottom-6 lg:left-1/2 lg:transform lg:-translate-x-1/2 hover:bg-orange-900 hover:text-white hover:op100 md:text-base"
        >
          {{ t('homepage.collection_cta.discover') }}
        </NuxtLinkLocale>
      </CollectionsProductGridCTA>
    </div>
    <div class="mx-auto mt-6 max-w-3xl px-4 lg:max-w-[88rem] md:max-w-4xl lg:px6 sm:px-6 sm:px4">
      <CollectionsProductGridCTA
        :search="{ collectionId: '8513', sort: { sales: 'DESC' as SortOrder.DESC }, take: 8 }"
        :banner-image="images['/assets/homepage/toys.png'] as string"
        bg-color="bg-blue-50"
        reverse
      >
        <h2 class="text-center text-xl text-blue-800 fw500 md:text-2xl">
          {{ t('homepage.collection_cta.toys_collection') }}
        </h2>
        <h3 class="mt2 whitespace-nowrap text-center text-blue-800 fw500 uppercase">
          {{ t('homepage.collection_cta.joy_starts_here') }}
        </h3>

        <NuxtLinkLocale
          to="/collections/8513"
          class="z-2 w-fit rd-md bg-blue-800 px4 py1 text-center text-sm text-white shadow-md lg:absolute lg:bottom-6 lg:left-1/2 lg:transform lg:-translate-x-1/2 hover:bg-blue-900 hover:text-white hover:op100 md:text-base"
        >
          {{ t('homepage.collection_cta.discover') }}
        </NuxtLinkLocale>
      </CollectionsProductGridCTA>
    </div>

    <div class="mx-auto max-w-3xl px-4 lg:max-w-[88rem] md:max-w-4xl lg:px6 sm:px-6 sm:px4">
      <div class="mb6">
        <h2 class="mt4 text-xl fw500 -mb-2">
          {{ t('homepage.bestsellers.title') }}
        </h2>
        <ProductsGrid
          @total="(v) => (total = v)"
          @loading="(loading) => (isLoading = loading)"
        />
      </div>
    </div>
  </div>
</template>
